import { render } from "./ModificaDataPage.vue?vue&type=template&id=0e2782ee"
import script from "./ModificaDataPage.vue?vue&type=script&lang=js"
export * from "./ModificaDataPage.vue?vue&type=script&lang=js"

import "./ModificaDataPage.vue?vue&type=style&index=0&id=0e2782ee&lang=css"

import exportComponent from "/home/ubuntu/gestionale-partner-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__